<template>
    <div class="add-form">
        <div class="add-form__row row-error" v-if="localError || addClientError">{{ localError || addClientError }}</div>

        <div class="add-form__row">
            <div class="add-form__col-left">
                <span>{{ $t('clients.addForm.appName') }}</span>
            </div>
            <div class="add-form__col-right">
                <div class="add-form__input">
                    <input
                        type="text"
                        v-model="value.clientName"
                    >
                    <span>{{ $t('clients.addForm.appNameHint') }}</span>
                </div>
            </div>
        </div>

        <div class="add-form__row">
            <div class="add-form__col-left">
                <span>{{ $t('clients.addForm.redirectURL') }}</span>
            </div>
            <div class="add-form__col-right">
                <div class="add-form__input">
                    <input
                        type="text"
                        v-model="value.clientUrl"
                    >
                    <span>{{ $t('clients.addForm.redirectURLHint') }}</span>
                </div>
            </div>
        </div>

        <div
            class="add-form__row"
            :class="addClientIsLoading ? 'add-form__row_disabled' : ''"
        >
            <div>
                <Button
                    v-if="!value.clientId"
                    type="primary"
                    @click.native="saveBtn"
                    class="da-ui--color__btn_fill"
                >
                    <span>{{ $t('clients.create') }}</span>
                </Button>

                <Button
                    v-if="value.clientId"
                    type="primary"
                    @click.native="updateBtn"
                    class="da-ui--color__btn_fill"
                >
                    <span>{{ $t('clients.save') }}</span>
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { ACTIONS as ACTIONS_CLIENTS } from '../../store/clients'

import Button from '../../components/ui/button'

export default {
    name: 'AddForm',

    components: {
        Button,
    },

    props: {
        value:  {
            type: Object,
            default: () => ({
                clientId: null,
                clientName: '',
                clientUrl: '',
            }),
            required: false,
        },
    },

    data: () => {
        return {
            localError: '',
        }
    },

    computed: {
        ...mapGetters([
            'addClientIsLoading',
            'addClientError',
        ])
    },

    watch: {
        value() {
            this.$emit('input', this.value)
        }
    },

    mounted() {},

    beforeDestroy() {
        this.$store.dispatch(ACTIONS_CLIENTS.CLEAR_ERROR)
    },

    methods: {
        updateBtn() {
            if (!this.value.clientName || !this.value.clientUrl) {
                return this.localError = this.$i18n.t('clients.error')
            } else {
                this.localError = ''
                this.$store.dispatch(ACTIONS_CLIENTS.UPDATE_CLIENTS, {
                    id: this.value.clientId,
                    client: {
                        name: this.value.clientName,
                        redirect: this.value.clientUrl,
                        errors: [],
                    },
                })
            }
        },

        saveBtn() {
            if (!this.value.clientName || !this.value.clientUrl) {
                return this.localError = this.$i18n.t('clients.error')
            } else {
                this.localError = ''
                this.$store.dispatch(ACTIONS_CLIENTS.PUT_CLIENTS, {
                    name: this.value.clientName,
                    redirect: this.value.clientUrl,
                    errors: [],
                })
            }
        },
    },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.add-form {
    margin: 0 auto;
    max-width: 560px;
    height: 80%;
    overflow-y: auto;

    &__row {
        @include bp('sm') {
            display: flex;
            justify-content: space-between;
        }

        &_disabled {
            opacity: .5;
            pointer-events: none;
        }
    }

    &__input {
        margin-bottom: 15px;

        @include bp('sm') {
            width: 400px;
            margin-bottom: 30px;
        }

        input {
            display: block;
            width: 100%;
            padding: 9px 15px;
            line-height: 25px;
            border: 1px solid #3e3e3e;
            background-color: #1f1f1f;
            border-radius: 4px;
            color: rgba(241, 241, 241, 1);

            &:focus {
                border-color: #f58808;
            }
        }

        span {
            display: block;
            width: 100%;
            font-size: 13px;
            color: rgba(90, 90, 90, 1);
            margin-top: 10px;
            line-height: 1.3;
        }
    }

    &__col-left {
        height: 45px;
        display: flex;
        align-items: center;

        span {
            line-height: 1.3;
            display: block;
            padding-right: 20px;
        }
    }
}

.row-error {
    background-color: #d24141;
    color: #fff;
    font-size: 12px;
    padding: 10px;
    border-radius: 3px;
    margin: 0;
    white-space: pre-wrap;

    @include bp('sm') {
        margin: 15px 0 30px;
    }
}
</style>
